<template>
  <div class="detail-overlay" v-if="visible">
    <button class="detail-close" @click="close" title="关闭">✕</button>
    <div class="detail-overlay-inner">
      <div class="breadcrumb"><a @click="close">首页</a><span class="sep">›</span><a @click="close">公司动态</a><span class="sep">›</span><span>详情</span></div>
      <h1 class="detail-title">{{ news.title }}</h1>
      <div class="detail-meta">
        <div class="detail-meta-item"><span>📅</span><span>{{ news.publishDate }}</span></div>
        <div class="detail-meta-item"><span>🏷️</span><span>公司动态</span></div>
      </div>
      <div class="detail-imgs" v-if="imgs.length">
        <img v-for="(img,i) in imgs" :key="i" :src="img" :alt="news.title" />
      </div>
      <article class="detail-body"><div v-html="news.content"></div></article>
      <div class="detail-back"><a @click="close">← 返回公司动态列表</a></div>
    </div>
  </div>
</template>
<script>
import { ImgUrl } from '@/unitils/doMain'
export default {
  name:'NewsDetailOverlay',
  data(){return{visible:false,news:{},imgs:[]}},
  methods:{
    open(item){
      this.news=item
      this.imgs=item.imgs?item.imgs.split(':').filter(Boolean).map(i=>ImgUrl+i):[]
      this.visible=true
      document.body.style.overflow='hidden'
    },
    close(){ this.visible=false; document.body.style.overflow='' }
  }
}
</script>
<style scoped>
.detail-overlay{position:fixed;top:0;left:0;width:100%;height:100%;z-index:200;background:var(--h25-bg);overflow-y:auto;-webkit-overflow-scrolling:touch}
.detail-overlay-inner{max-width:860px;margin:0 auto;padding:100px 36px 60px}
.detail-close{position:fixed;top:20px;right:24px;z-index:210;width:44px;height:44px;border-radius:50%;border:2px solid var(--h25-accent);background:var(--h25-accent);font-size:20px;color:var(--h25-white);cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .2s;line-height:1;box-shadow:0 2px 12px rgba(217,119,87,.35)}
.detail-close:hover{background:var(--h25-accent2);border-color:var(--h25-accent2);transform:scale(1.08);box-shadow:0 4px 18px rgba(217,119,87,.5)}
.breadcrumb{font-size:12px;color:var(--h25-muted);margin-bottom:8px;display:flex;align-items:center;gap:8px;flex-wrap:wrap}
.breadcrumb a{color:var(--h25-muted);cursor:pointer;transition:color .2s}
.breadcrumb a:hover{color:var(--h25-accent)}
.sep{color:var(--h25-muted2)}
.detail-title{font-size:clamp(24px,3.5vw,36px);line-height:1.25;font-weight:700;letter-spacing:-1px;margin-bottom:14px;color:var(--h25-text)}
.detail-meta{display:flex;gap:20px;align-items:center;flex-wrap:wrap;padding-bottom:28px;border-bottom:1px solid var(--h25-border);margin-bottom:32px}
.detail-meta-item{font-size:13px;color:var(--h25-muted);display:flex;align-items:center;gap:6px}
.detail-imgs{margin-bottom:32px}
.detail-imgs img{width:100%;max-height:500px;object-fit:contain;margin-bottom:16px;border-radius:var(--h25-radius)}
.detail-body{font-size:16px;line-height:2;color:var(--h25-text2)}
.detail-back{padding:40px 0;text-align:center}
.detail-back a{display:inline-flex;align-items:center;gap:8px;padding:12px 28px;border:1px solid var(--h25-border);border-radius:24px;color:var(--h25-text);font-size:14px;font-weight:500;cursor:pointer;transition:all .2s;background:var(--h25-white)}
.detail-back a:hover{border-color:var(--h25-accent);color:var(--h25-accent)}
@media(max-width:768px){.detail-close{top:12px;right:12px}.detail-overlay-inner{padding:80px 20px 40px}}
</style>
